import styled from "styled-components";
import {Button, Checkbox, Input} from "antd";
import {hexToRgbA} from "../../services/app";

export const Container = styled.div`
    background: linear-gradient(137.5deg, #39A086 29.77%, #80DDC8 101.61%), #FFFFFF;
    height: 100%;
    padding-bottom: 20px;
    min-height: 100%;
    overflow-y: auto;
`
export const Logo = styled.div`
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.main || "rgba(0,0,0,0)"};

    img {
        height: 36px;
        width: auto;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 24px;
`;
export const BodyScroll = styled.div`
    max-height: calc(100% - 116px);
    overflow-y: auto;
`;
export const Images = styled.div`
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 20px;
    overflow: hidden;
    max-height: 300px;
    width: calc(100% - 40px);
`;
export const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;

    &.loaded img {
        opacity: 1 !important;
    }

    &.loaded {
        height: auto !important;
    }
`;
export const ImageView = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.3s;
    opacity: 0;
`;

export const Title = styled.div`
    font-weight: 500;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
    color: ${props => !!props.theme.main ? "#1B1B1B" : "#fff"};
    padding: 0 14px;
    margin-bottom: 6px;
`;
export const Desc = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${props => !!props.theme.main ? "#494949" : "#fff"};
    padding: 0 14px;

    p, h1, h2, h3, h4, h5, ul {
        margin-bottom: 3px;
        margin-block: 0;
    }
`;

export const Footer = styled.div`
    padding: 3px 0px 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: transparent;
    position: relative;

    &:before {
        content: "";
        display: block;
        width: 100%;
        height: 12px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 1) 100%);
        position: absolute;
        top: -12px;
        left: 0;
    }

    &:after {
        content: "";
        display: block;
        width: 100%;
        height: 12px;
        // linear-gradient top to bottom transparent 0%, rgba(0, 0, 0, 0.1) 100%
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, ${props => hexToRgbA(props.theme.main, 0.2)} 100%);
        position: absolute;
        top: -12px;
        left: 0;
    }
`;

export const Next = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 20px;
    background: ${props => props.theme.main || "#1D896D"};
    border-radius: 50px;
    width: 238px;
    height: 48px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    color: #FFFFFF;
    border: none;
`;

export const Modal = styled.div`
    background: rgba(27, 27, 27, 0.5);
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`;
export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 16px 24px;
    background: #FFFFFF;
    backdrop-filter: blur(20px);
    border-radius: 16px;
`;
export const ModalContentHead = styled.div`
    padding-top: 12px;
    height: 60px;

    & svg {
        position: absolute;
        top: 16px;
        right: 16px;
    }
`;
export const ModalContentBody = styled.div`
    flex: none;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    & .content {
        //max-height: 100%;
        //overflow-y: auto;
        text-align: justify;
        // white-space: pre-wrap;
        overflow-x: hidden;
        flex: 1;
    }

    p, h1, h2, h3, h4, h5, ul {
        margin-bottom: 3px;
        margin-block: 0;
    }
`;
export const ModalContentFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-top: 16px;
    height: 50px;
`;
export const ModalContentHeadTitle = styled.div`
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
    text-transform: capitalize;
    color: #1B1B1B;

`;
export const ModalContentHeadDesc = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #494949;
    margin-top: 0px;
`;

export const ModalContentFooterCheck = styled(Checkbox)`
    & span:last-child {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        height: 20px;
        color: #494949;
    }

    & .ant-checkbox {
        top: 0;
        height: 20px;
    }

    &.ant-checkbox-wrapper {
        align-items: center;
        display: flex;
    }

    & .ant-checkbox-inner {
        width: 20px;
        height: 20px;
        border: 1.5px solid #BEBEBE;
        border-radius: 4px;
        overflow: hidden;
    }

    & .ant-checkbox-checked .ant-checkbox-inner {
        border-color: ${props => props.theme.main || "#1D896D"} !important;
        background: ${props => props.theme.main || "#1D896D"};
        border-radius: 4px;
    }
`;
export const ModalContentFooterSubmit = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 48px;
    background: ${props => props.theme.main || "#1D896D"} !important;
    border-radius: 50px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    color: #FFFFFF !important;
    border: none !important;
    width: 124px;

    &.ant-btn[disabled] {
        opacity: 0.7;
    }
`;
export const ModalContentFooterCancel = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 48px;
    background: #E9EEF6 !important;
    border-radius: 50px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    color: #494949 !important;
    border: none !important;
    width: 124px;

    &.ant-btn[disabled] {
        opacity: 0.7;
    }
`;

export const InputLabel = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: #5D5D5D;
    margin-top: 16px;
    margin-bottom: 3px;
`
export const InputView = styled(Input)`
    padding: 13px 16px;
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #BEBEBE;
    border-radius: 10px;
`


export const CloseIcon = (props: any) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3165 18.7071 18.7071C18.3165 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#626262"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70708 18.7071C6.31655 19.0977 5.68339 19.0977 5.29286 18.7071C4.90234 18.3166 4.90234 17.6835 5.29286 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
              fill="#626262"/>
    </svg>
)

export const ScrollDown = styled.div`
    color: #828282;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 16px;
    height: 50px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
`

export const IconScroll = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M12.0001 19.1643L18.2072 12.9572L16.793 11.543L12.0001 16.3359L7.20718 11.543L5.79297 12.9572L12.0001 19.1643ZM12.0001 13.5144L18.2072 7.30728L16.793 5.89307L12.0001 10.686L7.20718 5.89307L5.79297 7.30728L12.0001 13.5144Z"
                fill="#828282"/>
        </svg>
    )
}